import { render, staticRenderFns } from "./SaveCancelButtons.vue?vue&type=template&id=63c70465&"
import script from "./SaveCancelButtons.vue?vue&type=script&lang=js&"
export * from "./SaveCancelButtons.vue?vue&type=script&lang=js&"
import style0 from "./SaveCancelButtons.vue?vue&type=style&index=0&id=63c70465&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports